import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { formatingHeadersCemex, formatingHeadersMerz, formatingHeadersParesa, formatingHeadersSIMIAR } from "../../../redux/helpersHeadersPerProyect";
import { filterResponsesLastEntryPerDateCemex } from "../../../redux/helperResponsesPerProyect";
import { filteruserPerGrup } from "../../../helpers/LearningHelpersTable";
import { filterResponsesOnlyLastEntry } from "../../../redux/helpers";
import { onGetAllAlumsByGroups } from "../../../api";
import { CustomTable } from "../../../components";
import { setarrayDataCombinedToStore } from "../../../redux/VRL/thunks";
export const LearningTable = ({ grupSelected, dateRange, hasFilter }) => {
    const searchInput = useRef(null);
    const [headers, setHeaders] = useState();
    const [searchText, setSearchText] = useState('');
    const [usersByGroups, setusersByGroups] = useState([]);
    const [dataTable, setComponentDataTable] = useState([]);
    const { arrayData } = useSelector((state) => state.table);
    const [arrayDataCombined, setarrayDataCombined] = useState([])
    const { responses, proyectSelected, groups } = useSelector((state) => state.vrlSlice);
    const dispatch = useDispatch()
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(String(selectedKeys[0]).toLowerCase());
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };


    useEffect(() => {
        setusersByGroups([])
        const getUsers = async () => {
            setusersByGroups(await onGetAllAlumsByGroups(groups))
        }
        getUsers()
        // eslint-disable-next-line
    }, [groups])

    useEffect(() => {
        // nueva funcion 
        // si el grupo selecciondo es "all" regresa todos los usuarios mostrando primero los que ya han realizado la capacitacion
        // en caso contrario filtra las respuestas y TODO los usuarios para el grupo seleccionado en el componente padre de este
        let arrayDataCombined = filteruserPerGrup(grupSelected, arrayData, usersByGroups, groups)
        dispatch(setarrayDataCombinedToStore(arrayDataCombined))
        setarrayDataCombined(arrayDataCombined)
        // eslint-disable-next-line
    }, [grupSelected, usersByGroups])


    useEffect(() => {
        let headersBasic = formatingHeadersCemex(responses)
        // if (proyectSelected._id === "66155e601e91fe7bde671941") {
        //     console.log("this is SimiAR-headers");
        //     const headerSimi = headersBasic.filter(header => !(header.dataIndex.includes("Inicio") || header.dataIndex.includes("Final") || header.dataIndex.includes("sumatoria")))
        //     headerSimi[1] = ({
        //         dataIndex: "inicio",
        //         label: "inicio",
        //         key: "inicio",
        //         title: "inicio",
        //         width: 100,
        //     });
        //     headerSimi.splice(2, 0, {
        //         dataIndex: "fin",
        //         label: "fin",
        //         key: "fin",
        //         title: "fin",
        //         width: 100,
        //     });
        //     setHeaders(headerSimi)
        // }
        if (proyectSelected._id === "672e4328031ac03e79f58508") {
            console.log("CEMEX")
            headersBasic = formatingHeadersCemex(responses, "672e4328031ac03e79f58508", grupSelected, { searchInput, handleReset, handleSearch, })
            setComponentDataTable(filterResponsesLastEntryPerDateCemex(arrayDataCombined))
        }
        if (proyectSelected._id === "679965563ed6fed031d3b488") {
            // paresa
            console.log("PARESA")
            headersBasic = formatingHeadersParesa(responses, "679965563ed6fed031d3b488", grupSelected, { searchInput, handleReset, handleSearch, })
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayDataCombined))
        }
        else if (proyectSelected._id === "66104d3562bdb94c30339831") {
            console.log("MERZZZZZ")
            // MERZ prohyect
            headersBasic = formatingHeadersMerz(responses, "66104d3562bdb94c30339831")
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayDataCombined))
        }
        else if (proyectSelected._id === "6610c73702c6d8edebbe9154") {
            console.log("SIMI VR")
            // MERZ prohyect
            headersBasic = formatingHeadersMerz(responses, "6610c73702c6d8edebbe9154")
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayDataCombined))
        }
        else if (proyectSelected._id === "66155e601e91fe7bde671941") {
            console.log("SIMI AR")
            // SIMI AR
            headersBasic = formatingHeadersSIMIAR(responses, "66155e601e91fe7bde671941")
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayDataCombined))
        }
        else {
            headersBasic = formatingHeadersCemex(responses, proyectSelected._id)
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayDataCombined))
        }
        setHeaders(headersBasic)
        // eslint-disable-next-line 
    }, [responses, arrayDataCombined, proyectSelected])


    const [initialDate, endDate] = dateRange && hasFilter ? dateRange : [];
    const arrayDateWDates = dataTable.map((user) => ({ ...user, Fecha_y_hora: new Date(user.Fecha_y_hora) }))
    const filterByDate = arrayDateWDates.filter((user) => user.Fecha_y_hora >= initialDate && user.Fecha_y_hora <= endDate && user.Nombre.includes(searchText));
    const stringDate = filterByDate.map((user) => ({
        ...user,
        Fecha_y_hora: moment(user.Fecha_y_hora, "MM DD YYYY hh:mm:ss").format("MM/DD/YYYY hh:mm:ss"),
    }));



    return (
        <div className="h-full ">
            <div className="h-full ">
                <CustomTable data={hasFilter ? stringDate : dataTable.filter(user => String(user.Nombre).toLowerCase().includes(searchText))} columns={headers} />
            </div>
        </div>
    );
};
